import { Skeleton } from '@/components/ui';

export function SettingsHouseholdSkeleton() {
  return (
    <div className="flex flex-col items-center gap-6 px-5 py-6">
      {/* Avatar */}
      <div className="flex flex-col items-center gap-2">
        <Skeleton
          variant="circular"
          className="w-20 h-20"
        />
        <Skeleton className="h-3.5 w-32" />
      </div>

      {/* Name input */}
      <div className="w-full flex flex-col gap-1.5">
        <Skeleton className="h-4 w-28" />
        <Skeleton className="h-10 w-full rounded-md" />
      </div>
    </div>
  );
}
